import { string } from "yup";
export var CouponText;
(function (CouponText) {
    CouponText["APPLY_COUPON"] = "Apply Coupon";
    CouponText["APPLY"] = "Apply";
    CouponText["CANCEL"] = "Cancel";
    CouponText["CONFIRM"] = "Confirm";
    CouponText["COUPON_CODE_REQUIRED_MESSAGE"] = "Please enter a coupon code";
    CouponText["COUPON_CODE"] = "Coupon code";
    CouponText["COUPON_NOT_VALID"] = "Coupon is not valid!";
    CouponText["COUPON_APPLIED"] = "Coupon Applied";
    CouponText["TERMS_MODAL_HEADER"] = "Discount Terms";
    CouponText["TERMS_MODAL_CANCEL"] = "You must agree to the terms to use this coupon";
})(CouponText || (CouponText = {}));
export const couponFormSchema = {
    couponCode: string().required(CouponText.COUPON_CODE_REQUIRED_MESSAGE),
};
